import { useState } from "react";
import { CaretDown, ArrowLeft } from "@phosphor-icons/react";
import MarkerStroke from "./MarkerStroke";
import useReveal from "./useReveal";
import "./home.css";
import "./HomeFAQ.css";

/*
 * The 16 questions/answers below are mirrored 1:1 by the FAQPage JSON-LD in
 * public/index.html. Any text change here MUST be synced there in the same commit.
 */

const FAQS = [
  {
    question: "מהי תוכנה לניהול קליניקה?",
    answer:
      "תוכנה לניהול קליניקה היא מערכת דיגיטלית שמרכזת את כל הניהול של קליניקה טיפולית במקום אחד – יומן ופגישות, תיק מטופל, סיכומי טיפול, תזכורות, חשבוניות, טפסים וניהול פיננסי. במקום לנהל את הקליניקה באקסל, ביומן ידני ובפנקס חשבוניות נפרד, הכל מתנהל ממערכת אחת מאובטחת. CliniKit היא מערכת לניהול קליניקה בעברית שנבנתה במיוחד עבור מטפלים בישראל.",
  },
  {
    question: "כמה עולה תוכנה לניהול קליניקה?",
    answer:
      "המחיר של CliniKit מתחיל ב-39.90 ₪ לחודש למסלול המתחילים, ו-89.90 ₪ לחודש למסלול המקצועי עם גישה מלאה לכל הכלים וללא הגבלת מטופלים. אפשר להתחיל ב-30 ימי ניסיון חינם ללא כרטיס אשראי, ולבטל בכל עת ללא דמי ביטול.",
  },
  {
    question: "מה כולל תקופת הניסיון של 30 יום?",
    answer:
      'תקופת הניסיון כוללת גישה לכל הפיצ\'רים של התוכנית "מקצועי" - כולל יומן חכם, ניהול מטופלים, תזכורות SMS, סיכומי AI ועוד. תוכלו לנסות את המערכת ולהחליט אם היא מתאימה לכם. תקופת הניסיון מוגבלת ל-15 מטופלים ו-20 הודעות SMS. אין צורך בכרטיס אשראי כדי להתחיל.',
  },
  {
    question: "האם המידע של המטופלים שלי מאובטח?",
    answer:
      "בוודאי. אבטחת מידע היא העדיפות הראשונה שלנו. כל המידע מוצפן בתקן AES-256, השרתים שלנו עומדים בתקן SOC2, ואנחנו עובדים לפי דרישות GDPR ותקנות הפרטיות המחמירות ביותר. המידע שלכם בטוח ומוגן.",
  },
  {
    question: "איך מבטלים מנוי אם אני לא מרוצה?",
    answer:
      "ביטול מנוי פשוט וזריז - אפשר לעשות את זה ישירות מהגדרות החשבון בלחיצת כפתור, או בפנייה קצרה לצוות התמיכה. אין דמי ביטול, והמנוי נשאר פעיל עד סוף התקופה ששילמתם עליה. אין הפתעות.",
  },
  {
    question: "האם יש אפליקציה לנייד?",
    answer:
      "המערכת מותאמת ב-100% לשימוש בנייד. אפשר להוסיף אותה למסך הבית והיא תיראה ותתנהג בדיוק כמו אפליקציה רגילה – כולל התראות Push על אירועים חשובים בזמן אמת, כמו אישורי הגעה, ביטולים ועוד.",
  },
  {
    question: "איך עובדות התזכורות למטופלים?",
    answer:
      "כל מטופל מקבל שתי הודעות SMS אוטומטיות לפני כל פגישה. הראשונה נשלחת 24 שעות מראש כתזכורת מוקדמת, והשנייה נשלחת כשעתיים לפני הפגישה וכוללת קישור לאישור הגעה. כך תקבלו אינדיקציה ברורה מי אישר הגעה ומי ביטל – ותוכלו לנהל את היומן בהתאם. אפשר גם להתאים את התזמון ואת ההגדרות בהתאם להעדפות שלכם.",
  },
  {
    question: "האם CliniKit מתאימה לריפוי בעיסוק?",
    answer:
      "בהחלט. CliniKit מתאימה למרפאים ומרפאות בעיסוק בכל ההתמחויות – התפתחות הילד, ויסות חושי, כתיבה ומוטוריקה עדינה, שיקום נוירולוגי וגריאטריה. המערכת כוללת יומן חכם, ניהול מטופלים, סיכומי טיפול עם AI, תזכורות SMS, חשבוניות וניהול פיננסי.",
  },
  {
    question: "האם המערכת מתאימה לפסיכולוגים ופסיכותרפיסטים?",
    answer:
      "כן. CliniKit מספקת סביבה מאובטחת לפסיכולוגים ופסיכותרפיסטים מכל ההתמחויות – קלינית (מבוגרים/ילדים), שיקומית, חינוכית, CBT, LICBT ו-DBT. המערכת כוללת ניהול תיקי מטופלים, תיעוד מפגשים מאובטח, סיכומי AI ואבטחת מידע רפואי ברמה הגבוהה ביותר.",
  },
  {
    question: "האם CliniKit מתאימה ליועצת שינה או למדריכת הורים?",
    answer:
      "בוודאי. CliniKit מושלמת ליועצות שינה, מדריכי הורים ויועצים משפחתיים – בתחומי ייעוץ שינה, גמילה, הפרעות קשב (ADHD), גיל ההתבגרות וקשיי ויסות. המערכת כוללת ניהול לקוחות, יומן פגישות, תזכורות, תיעוד מפגשים וסיכומים חכמים.",
  },
  {
    question: "האם אפשר לנהל קליניקה עם מספר סוגי מטפלים?",
    answer:
      "כן. CliniKit תוכננה לתמוך בקליניקות מולטי-דיסציפלינריות – ריפוי בעיסוק, פיזיותרפיה, פסיכולוגיה, קלינאות תקשורת, טיפול רגשי ועוד – הכל תחת חשבון קליניקה אחד. כל מטפל מקבל גישה מותאמת, יומן אישי, וניהול מטופלים עצמאי, עם יכולות ניהול מרכזיות למנהל הקליניקה.",
  },
  {
    question: "האם CliniKit מתאימה לתזונאים, נטורופתים או רפואה סינית?",
    answer:
      "כן. CliniKit מתאימה לתזונאים ודיאטנים (דיאטה קלינית, תזונת ספורט, הפרעות אכילה), לנטורופתים (צמחי מרפא, אירידיאולוגיה, פרחי באך) ולמטפלים ברפואה סינית ומשלימה (דיקור סיני, שיאצו, טווינא, רפלקסולוגיה). כל מקצוע מקבל כלי תיעוד מותאמים.",
  },
  {
    question: "האם אפשר לגבות תשלומים ולסלוק כרטיסי אשראי דרך CliniKit?",
    answer:
      "כן. CliniKit כוללת דפי תשלום מאובטחים שנשלחים למטופל ב-WhatsApp או SMS, סליקת כרטיסי אשראי, הפקת חשבוניות וקבלות אוטומטית (התממשקות ל-Morning / חשבונית ירוקה ול-Grow), לוח גבייה שמראה מה שולם ומה ממתין, תזכורות תשלום ודוחות כספיים – הכל בתוך המערכת, בלי כלי חיצוני.",
  },
  {
    question: "האם CliniKit מתאימה גם לסטודיו יופי – קוסמטיקה, גבות, ציפורניים ושיער?",
    answer:
      "בהחלט. CliniKit מתאימה לכל קליניקה וסטודיו שעובדים בתורים: מטפלות פנים וקוסמטיקאיות, סטודיו לעיצוב גבות וריסים, סטודיו ציפורניים, מספרות וסטודיו לשיער, הסרת שיער בלייזר, עיסוי וספא, איפור קבוע ואסתטיקה. יומן, תזכורות WhatsApp, קביעת תורים עצמאית, דפי תשלום, כרטיס לקוח וטופסי הצהרת בריאות – הכל במקום אחד.",
  },
  {
    question: "איזו תמיכה מקבלים ב-CliniKit?",
    answer:
      "תמיכה אישית באמת: נציג אנושי ב-WhatsApp, ליווי אישי בהקמה ובהעברת הנתונים מהמערכת הקודמת או מאקסל, סיורים מודרכים – ולני, עוזר AI בתוך המערכת שעונה בעברית על כל שאלה תפעולית וטכנית 24/7. פיצ'רים חדשים נבנים מבקשות של מטפלים.",
  },
  {
    question: "למה CliniKit נחשבת למשתלמת ולבטוחה ביותר?",
    answer:
      "כי הכל כלול במחיר אחד: אבטחת מידע ברמה רפואית, תמיכה אישית, WhatsApp/SMS, AI, דפי תשלום וטפסים. אין צורך לרכוש ולתחזק חמישה כלים נפרדים, ואין צורך לדאוג לאבטחה – האחריות על הגנת המידע שלכם היא שלנו, כמו ביטוח. מתחילים ב-39.90 ₪ לחודש, מבטלים בכל עת, ומייצאים את כל הנתונים בכל רגע.",
  },
];

function HomeFAQ() {
  const [openIndex, setOpenIndex] = useState(0);
  const ref = useReveal();

  const toggle = (index) => setOpenIndex(openIndex === index ? null : index);

  return (
    <section id="faq" className="home-section home-section--white hfaq" aria-labelledby="hfaq-title">
      <div className="home-container home-container--narrow">
        <div className="home-head home-head--center">
          <h2 id="hfaq-title" className="home-h2 home-h2--display">
            כל מה{" "}
            <span className="home-mark">
              שמטפלים שואלים
              <MarkerStroke />
            </span>{" "}
            על תוכנה לניהול קליניקה
          </h2>
          <p className="home-sub">
            לא מצאתם תשובה?{" "}
            <a href="#contact" className="home-link">
              דברו איתנו
              <ArrowLeft size={14} weight="bold" />
            </a>
          </p>
        </div>

        <div className="hfaq-list home-reveal" ref={ref}>
          {FAQS.map((faq, index) => (
            <div key={index} className={`hfaq-item${openIndex === index ? " hfaq-item--open" : ""}`}>
              <button
                className="hfaq-question"
                onClick={() => toggle(index)}
                aria-expanded={openIndex === index}
                aria-controls={`hfaq-answer-${index}`}
              >
                <span className="hfaq-question-text">{faq.question}</span>
                <CaretDown size={17} weight="bold" className="hfaq-caret" />
              </button>
              <div className="hfaq-answer" id={`hfaq-answer-${index}`}>
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HomeFAQ;
